import {_get, _post, clubId} from "@api/doinsport/services/httpService";

const URI = "/clubs/participants/categories"


export const getClubCategories = (itemsPerPage) => _get(URI +'?club.id=' + clubId + '&itemsPerPage=' + itemsPerPage);

export const postClubCategory = (category) => _post(URI, category);
